import { useCurrentUser, useToastProvider } from '@qualio/ui-components';
import { useQuery } from 'react-query';
import { documentApi } from '../api/document';

type UseDocumentUpgradeInformationProps = {
  canApplyTemplateChanges: boolean;
  documentId: number;
};
export const useDocumentUpgradeInformation = ({
  canApplyTemplateChanges,
  documentId,
}: UseDocumentUpgradeInformationProps) => {
  const currentUser = useCurrentUser();
  const { showToast } = useToastProvider();
  const getDocumentUpgradeInformation = async () => {
    return await documentApi.getDocumentUpgradeInformation(
      currentUser.companyId,
      documentId,
    );
  };

  return useQuery({
    queryFn: getDocumentUpgradeInformation,
    queryKey: ['upgradeInfo', documentId, currentUser.companyId],
    refetchOnWindowFocus: false,
    enabled: canApplyTemplateChanges,
    onError: () => {
      showToast({
        'data-cy': 'document-upgrade-information-error-toast',
        status: 'error',
        title: 'Error',
        description:
          "Failed to load information on the document's template version. Please refresh.",
      });
    },
  });
};
